




























































































































































































































import Vue from 'vue'
import { postSite,patchSite } from '@/modules/site/site.service';
//import { updateGuestCategories } from '@/modules/event/guest-category.service';

export default Vue.extend({
    name: 'SiteForm',
    props: ['formTitle','formAction','dataSiteProp'],
    
    data: () => ({
      siteFormDialog: false,
      openedPanel: null,
      msgError: '',
      msgSuccess: '',
      buttonTitle: 'Créer',
      buttonIcon: 'mdi-pencil-plus-outline',
      siteData: {
        name:'',
        address:'',
        postalCode:'',
        city:'',
        country:'',
        logoUrl: '',
        contactEmail: ''
      }, 
      guestCategoryInput: '',
      guestCategories: [] as any[],
      questionTypes: [{label:'TEXT',description:'Texte'},{label:'CHECKBOX',description:'Case à cocher'}],
      rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
    }),
    mounted() {
      this.initProps();
    },
    methods: {
      initProps() {
        if (this.dataSiteProp){
          this.buttonTitle = '';
          this.buttonIcon = 'mdi-file-document-edit-outline';
          this.siteData = this.dataSiteProp;
          // if (this.dataSiteProp.guestCategories){
          //   this.guestCategories = this.dataSiteProp.guestCategories;
          // }
        }
      },
      addQuestion(guestCategoryIndex){
        
        if (!this.guestCategories[guestCategoryIndex].questions){
          this.guestCategories[guestCategoryIndex].questions = [];
        }

        const question = {
          questionLabel: '',
          questionType: 'TEXT'
        };
        if (this.guestCategories[guestCategoryIndex].id){
         question.guestCategoryId = this.guestCategories[guestCategoryIndex].id;
        }
        this.guestCategories[guestCategoryIndex].questions.push(question);
      },
      handleClick() {
        this.$emit('click');
      },
      close(reset: boolean) {
        if (reset)
          this.resetData();
        this.siteFormDialog = false;
        this.handleClick();
      },
      resetData(){
        this.siteData = {
          name:'',
          address:'',
          postalCode:'',
          city:'',
          country:'',
          logoUrl: '',
          contactEmail: ''
        };
        this.msgError = '';
        this.msgSuccess = '';
      },
      saveNewGuestCategory(){
        this.guestCategories.push({name:this.guestCategoryInput,questions:[]});
        this.guestCategoryInput = '';
        this.openedPanel = null;
      },
      saveEditGuestCategory(){
        this.openedPanel = null;
      },
      saveSite(){
        if (this.dataSiteProp && this.dataSiteProp.id){
          this.updateSite(this.dataSiteProp.id);
        }else{
          this.createSite();
        }
      },
      createSite(){
        this.msgSuccess = '';
        this.msgError= '';
        postSite(this.siteData).then(res=>{
            if (res.data && res.data.id){
              // if (this.guestCategories && this.guestCategories.length>0){
              //   updateGuestCategories(this.guestCategories,res.data.id).then(res=>{
              //     if (res.data){
              //       this.msgSuccess = 'Site créé et ' + res.data.successData.length + ' groupes créées';
              //       this.close(true);
              //     }else if (res.error){
              //       this.msgError = res.data.errorData.length>0?(res.data.errorData.length+' groupes en erreur.'):'';
              //     }
              //   });
              // }else {
                this.msgSuccess = 'Site créé';
                this.close(true);
              //}
            }else if (res.error){
              this.msgError = 'Erreur dans la création du site.'
            }
        });
      },
      updateSite(siteId: number){
        this.msgSuccess = '';
        this.msgError= '';
        patchSite(siteId, this.siteData).then(res=>{
            if (res.data){
              // if (this.guestCategories && this.guestCategories.length>0){
              //   updateGuestCategories(this.guestCategories,siteId).then(res=>{
              //     if (res.data){
              //       this.msgSuccess = 'Site modifié et ' + res.data.successData.length + ' groupes créées';
              //       this.close(false);
              //     }else if (res.error){
              //       this.msgError = res.data.errorData.length>0?(res.data.errorData.length+' groupes en erreur.'):'';
              //     }
              //   });
              // }else{
                this.msgSuccess = 'Site modifié';
                this.close(false);
              //}
            }else if (res.error){
                this.msgError = 'Erreur dans la modification du site.'
            }
        });
      },
    }
  })
